// refers to the first argument of a compare function
export type Compared = Compared.Greater | Compared.Same | Compared.Smaller;

export namespace Compared {
	export type Greater	= 1;
	export type Same	= 0;
	export type Smaller	= -1;

	export const greater:Compared	= 1;
	export const same:Compared		= 0;
	export const smaller:Compared	= -1;

	export const normalize	= (it:number):Compared	=>
		it < 0 ? smaller : it > 0 ? greater : same;

	export const inverse	= (it:number):Compared	=>
		it < 0 ? greater: it > 0 ? smaller : same;
}
